









import DineroFactory, { Dinero } from "dinero.js";

import { ref, computed, defineComponent } from "@vue/composition-api";

interface Props {
  value: Dinero;
}

export default defineComponent<Props>({
  name: "MoneyInput",
  props: {
    value: { type: Object, default: () => DineroFactory() }
  },
  setup(props: Props, context) {
    const formatted = computed(() => props.value.toFormat());

    return {
      formatted,
      format: (e: KeyboardEvent) => {
        context.emit(
          "input",
          DineroFactory({
            amount: +e.target.value.replaceAll(/[^\d]/g, ""),
            precision: 2
          })
        );
      }
    };
  }
});
